/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actionsCard } from "../../../bus/card/actions";
import { socket } from "../../../REST/api";
import { Portal } from "react-portal";
import PopupError from "../../_popup/PopupError";
import CanvasForm from "../CanvasForm/index";

import { CardDiv, DotsImg } from "./styles";
import { regexFormat } from "../../../utils/functions";

import dots from "../../../static/dots.svg";

const CanvasCardNoDragg = ({ cards, subtitle, listID }) => {
  const cardList = useSelector((state) =>
    state.updateCardReducer.get("cardList")
  );
  const { accessToken: token } = useSelector((state) =>
    state.updateAuthReducer.get("authData")
  );

  const dispatch = useDispatch();
  const [error, seterror] = useState(false);
  const [enter, setenter] = useState(false);

  const [isEditing, setIsEditing] = useState(false);
  const [cardText, setcardText] = useState("+");
  const [buffer, setbuffer] = useState("+");

  const [select, setSelect] = useState(false);
  const [coords, setCoords] = useState([0, 0]);

  useEffect(() => {
    if (cards.length === 0) {
      setcardText(subtitle);
      setbuffer(subtitle);
    } else if (enter) {
      setcardText("");
    } else {
      setcardText("+");
    }
  }, [cards]);

  function showSelection() {
    if (window.getSelection().toString() !== "") {
      setSelect(true);

      const coord = window.getSelection().focusNode.parentNode.offsetTop;
      setCoords([coord + 13 + "px", 5 + "px"]);
    } else {
      setSelect(false);
    }
  }

  const handleAddCard = (e, entering) => {
    const newString = regexFormat(e.target.innerHTML);
    setenter(entering);

    if (newString === "" && cards.length === 0) {
      setcardText(buffer);
      setIsEditing(false);
      setSelect(false);
    } else if (newString === "") {
      setcardText("+");
      setIsEditing(false);
      setSelect(false);
    } else {
      setcardText(newString);
      setIsEditing(false);
      setSelect(false);
      dispatch(actionsCard.addCard([{ text: newString, listID }, cardList]));
      const id = window.location.pathname.substring(1);

      socket.emit(
        "updateCanvas",
        { canvasId: id, canvasData: cardList, token },
        (data) => {
          if (data.statusCode !== undefined) {
            seterror(true);
            console.log(data, "addCard");
          }
        }
      );

      if (entering) {
        setIsEditing(true);
      } else {
        setIsEditing(false);
      }
    }
  };

  const openForm = () => {
    setcardText("");
    setIsEditing(true);
  };

  const renderCard = () => {
    return (
      <>
        {error && (
          <Portal>
            <PopupError />
          </Portal>
        )}
        <CardDiv
          style={!isEditing ? { fontSize: "12px" } : {}}
          onClick={() => openForm()}
          id="cardDivEdit"
        >
          <DotsImg src={dots} />

          <CanvasForm
            cardText={cardText}
            showSelection={showSelection}
            isEditing={isEditing}
            saveCard={handleAddCard}
            coords={coords}
            select={select}
          />
        </CardDiv>
      </>
    );
  };

  return renderCard();
};

export default CanvasCardNoDragg;
